import { DestroyRef, inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Injectable({
	providedIn: 'root'
})
export abstract class IFilterListService<T> {
	readonly graphQlService = inject(GraphQLService);
	readonly appService = inject(AppService);
	readonly destroyRef = inject(DestroyRef);

	loading = false;
	datasource: BehaviorSubject<Array<Selectable<T>>> = new BehaviorSubject<Array<Selectable<T>>>([]);

	get datasourceLabel(): string {
		return this.datasource.getValue().join(', ').slice(0, 20);
	}

	abstract search(searchText: string, variables?: any, append?: boolean): void;

	loadNextPage(): void {}

	preloadUntilSelected(selected: Array<Selectable<T>>, searchText: string = '', variables?: any): void {
		this.search(searchText, variables);
	}

	toggleSelection(item: Selectable<T>): void {
		const actualValue = this.datasource.getValue();
		const updated = actualValue.map((el) => (el.displayId === item.displayId ? { ...el, selected: false } : el));
		this.datasource.next(updated);
	}

	toggleRemoveSelection(item: Selectable<T>): void {
		const actualValue = this.datasource.getValue();
		const updated = actualValue.map((el) => (el.displayId === item.displayId ? { ...el, selected: false } : el));
		this.datasource.next(updated);
	}
}
